import { render } from "./BuyFE.vue?vue&type=template&id=65f9196c"
import script from "./BuyFE.vue?vue&type=script&lang=js"
export * from "./BuyFE.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__